/* 首页信息相关接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'


// 轮播图
export function getIndexPic () {
  return axios({
    url: path.mobile + '/index/getIndexPic',
    method: 'GET'
  })
}

// 公告
export function getNoticeList () {
  return axios({
    url: path.mobile + '/index/getNoticeList',
    method: 'GET'
  })
}


// 公告
export function getNoticeById (id) {
  return axios({
    url: path.mobile + '/index/getNoticeById/'+id,
    method: 'GET'
  })
}




// 公告
export function getVenueInfoList () {
  return axios({
    url: path.mobile + '/index/getVenueInfoList',
    method: 'GET'
  })
}
